import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import SkinAssessmentButton from "../../../../../common/skinAssessmentButton/SkinAssessmentButton";

import "./CardQuestionTemplate.scss";
import config from "../../../../../config";
import { getSectionId } from "../utility";
import { SKIN_ASM_CONSTANTS, SKIN_ASSESSMENT_QUESTION_TEMPLATE, SKIN_ASSESSMENT_QUESTION_TEMPLATE_M1 } from "../../../../../common/skinAssessmentConstant";


const CardQuestionTemplate = ({ question, onAnswerSelect, savedAnswerIds = [] }) => {

    const [selectedAnswerId, setSelectedAnswerId] = useState(null);
    const [currentSlide, setCurrentSlide] = useState(0);

    const questionLabel = getSectionId(question?.question_label);
    const titleClassName = SKIN_ASSESSMENT_QUESTION_TEMPLATE[questionLabel]?.qTitleBgClassName;
    const questionNotSure = question?.question_label.toLowerCase() === SKIN_ASSESSMENT_QUESTION_TEMPLATE_M1.NOT_SURE.label.toLowerCase();
    const btnSelectedClassName = SKIN_ASSESSMENT_QUESTION_TEMPLATE[questionLabel]?.selectedCard;

    const sliderRef = useRef(null);

    const sliderSettings = {
        dots: true,
        arrows: false,
        infinite: false,
        speed: 400,
        slidesToShow: 1.6,
        slidesToScroll: 1,
        swipeToSlide: true,
        variableWidth: false,
        centerMode: false,
        afterChange: (current) => setCurrentSlide(current),
        dotsClass: "slick-dots custom-dots",
    };

    const totalSlides = question?.question_value?.length || 0;
    const isEndSlide = currentSlide >= (totalSlides - 1.6);

    useEffect(() => {
        if (savedAnswerIds.length) {
            const answerId = savedAnswerIds[0];

            setSelectedAnswerId(answerId);
        } else {
            setSelectedAnswerId(null);
        }
    }, [savedAnswerIds, question?.question_label, question?._id]);

    useEffect(() => {
        if (!sliderRef.current) return;

        if (savedAnswerIds.length && !selectedAnswerId) {
            return;
        }

        if (!selectedAnswerId) {
            sliderRef.current.slickGoTo(0, false);
            setCurrentSlide(0);
            return;
        }

        const selectedIndex = question?.question_value?.findIndex((item) => item._id === selectedAnswerId);

        if (selectedIndex >= 0) {
            sliderRef.current.slickGoTo(selectedIndex, false);
            setCurrentSlide(selectedIndex);
        }
    }, [savedAnswerIds?.length, selectedAnswerId, question?._id, question?.question_label]);

    const handleSelect = (option) => {
        const index = question?.question_value?.findIndex((item) => item?._id === option._id);

        setSelectedAnswerId(option?._id);

        if (index >= 0 && sliderRef.current) {
            sliderRef.current.slickGoTo(index, false);
        }

        onAnswerSelect({ canGoNext: true, nextLabel: option.next_question || null, question_id: question._id, question_label: question.question_label, answer_ids: [option._id] });
    }

    const renderSkinTypeCard = (item, index) => {
        const isSelected = selectedAnswerId === item?._id;

        return (
            <div className="skin-type-card" key={`skin-card-${item._id}-${index}`}>
                {item.image_url && <img
                    src={`${config.S3_URL}${item.image_url}`}
                    alt="skin-type"
                    className="skin-type-image"
                />}
                <div className="skin-card-btn-wrapper">
                    <SkinAssessmentButton onBtnClick={() => { handleSelect(item) }} btnClassName={`skin-card-btn ${isSelected ? btnSelectedClassName : ''}`}>{SKIN_ASM_CONSTANTS.CHOOSE_BTN}</SkinAssessmentButton>
                </div>
            </div>
        )
    }

    const renderSkinTypeNotSureCard = (item) => {
        const isSelected = selectedAnswerId === item?._id;

        return (
            <div className="skin-type-not-sure-card" key={item._id}>
                {item.image_url && <img
                    src={`${config.S3_URL}${item.image_url}`}
                    alt="skin-type"
                    className="skin-type-not-sure-image"
                />}
                <SkinAssessmentButton onBtnClick={() => { handleSelect(item) }} btnClassName={`skin-card-btn ${isSelected ? btnSelectedClassName : ''}`}>{SKIN_ASM_CONSTANTS.CHOOSE_BTN}</SkinAssessmentButton>
            </div>
        )
    }

    return (
        <div className="card-type-question">
            <div className={`card-type-question-title ${titleClassName} ${questionNotSure ? 'not-sure-title' : ''}`}>
                {question.question}{question?.description ? <><br /><span className={`card-type-question-span`}>{question?.description}</span></> : null}
            </div>
            <div className={`card-type-question-slider ${isEndSlide ? 'is-at-end': ''}`}>
                <Slider key={question?._id} ref={sliderRef} {...sliderSettings}>
                    {question?.question_value?.map((item, index) => renderSkinTypeCard(item, index))}
                </Slider>
            </div>
        </div>
    )
}

export default CardQuestionTemplate;